var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import createMessageClass from './LoadingMessage.styles';
import useInterval from '../../utilities/components/useInterval';
var DELAY = 4000; // Delay in ms
var Message = function (_a) {
    var message = _a.message, color = _a.color;
    var messageClass = createMessageClass(color);
    return _jsx("p", { className: messageClass, children: message });
};
// Sequentially renders messages after each DELAY
var MessageTrain = function (_a) {
    var message = _a.message, color = _a.color;
    var _b = useState(0), messageIndex = _b[0], setMessageIndex = _b[1];
    var tick = function () {
        if (messageIndex === message.length - 1) {
            return;
        }
        setMessageIndex(messageIndex + 1);
    };
    useInterval(tick, DELAY);
    return (_jsx(AnimatePresence, { children: _jsx(motion.div, { initial: "hidden", animate: "show", exit: "exit", variants: variants, children: _jsx(Message, { message: message[messageIndex], color: color }) }, "loading-text-".concat(messageIndex)) }));
};
var variants = {
    hidden: {
        opacity: 0,
        transition: { duration: 0.15 }
    },
    show: {
        opacity: 1,
        transition: {
            delay: 0.3,
            default: { duration: 0.3 }
        }
    },
    exit: {
        opacity: 0,
        transition: { duration: 0.15 }
    }
};
var LoadingMessage = function (props) {
    var message = props.message;
    if (Array.isArray(message)) {
        if (message.length === 1) {
            return _jsx("p", { children: message[0] });
        }
        return _jsx(MessageTrain, __assign({}, props));
    }
    return _jsx(Message, __assign({}, props));
};
export default LoadingMessage;
